<template>
  <div class="school">
    <iframe :src="schoolUrl" frameborder="0" class="school_content"></iframe>
    <div class="loginBack" @click="goBack" @touchend="goBack" :style="schoolRight">返回註冊登錄</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      schoolUrl: ''
    };
  },

  methods: {
    goBack() {
      this.$router.push('/login');
    }
  },

  computed: {
    schoolRight() {
      let scrollWidths = document.body.scrollWidth;
      if (scrollWidths > 600) {
        this.schoolUrl = 'https://promotion.house730.com/newuser_pc/';
      } else {
        this.schoolUrl = 'https://promotion.house730.com/newuser_app/';
      }
    }
  }
};
</script>
<style lang="scss">
.school {
  width: 100%;
  height: 100%;
  position: fixed;
  // -webkit-overflow-scrolling: touch;
  .school_content {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    z-index: -1;
  }

  .loginBack {
    cursor: pointer;
    position: absolute;
    right: 20px;
    bottom: 30px;
    color: #fff;
    font-size: 14px;
    z-index: 99;
  }
}
@media screen and (min-width: 1125px) {
  .school {
    .loginBack {
      right: calc(100% - 1125px) + 20px;
    }
  }
}
</style>
